import { Record, Map } from "immutable";
import { TaskRecord, taskFromJSON } from "common/records/Task";
import { RootActions, RootState } from "common/reducers";
import { RECEIVE_TASK } from "common/reducers/task.actions";

export const TaskStateRecord = Record({
  byId: Map<string, TaskRecord>(),
});

export const initialState = TaskStateRecord();

export const model = "tasks";

export const reducer = (state: RootState, action: RootActions): RootState => {
  if (state && !state.get(model)) {
    state = state.set(model, initialState);
  }
  switch (action.type) {
    case RECEIVE_TASK:
      state = state.setIn([model, "byId", action.payload.id], taskFromJSON(action.payload));
      return state;
    default:
      return state;
  }
};
